import {Step} from './steps/step';
import {Steps} from './steps/steps';
import {Router} from '@angular/router';

export abstract class ApplicationFlowNavigator {
    protected readonly steps: Steps;
    protected readonly router: Router;

    protected constructor(steps: Steps, router: Router) {
        this.steps = steps;
        this.router = router;
    }

    public async navigateToNext(currentStep: new(...args: any[]) => Step): Promise<void> {
        const nextUrl = (await this.steps.findNext(currentStep)).url();
        await this.router.navigate([nextUrl]);
    }

    public async navigateToPrevious(currentStep: new(...args: any[]) => Step): Promise<void> {
        const previousUrl = (await this.steps.findPrevious(currentStep)).url();
        await this.router.navigate([previousUrl]);
    }
}